module.exports = __webpack_public_path__ + "img/Save.9ee625c4.svg";